import styled from 'vue-styled-components';

const Link = styled.div`
    display: flex;
    color: ${props => props.color};
`;

export { Link };
